<template>
  <div class="tab">
    <div>
      <span @click="returnFun()">＜返回</span>
      <h4>什么是成长型思维</h4>
      <p>成长型思维模式的概念由斯坦福大学心理学教授卡罗尔·德韦克（Carol Dweck）提出。拥有成长型思维的人相信自己的智力和能力可以通过努力得到提升。拥有成长型思维的人往往会愿意应对更多挑战，在面对困难时也更加坚韧不拔。而且往往越在困境，成就越突出。德韦克教授于2017年被授予全球最大的教育类奖项 —— 一丹教育研究奖。</p>
      <h4>固定型思维vs. 成长型思维</h4>
      <p>核心区别：看待智力和能力的方式不同</p>
      <img src="../../assets/list4.png" alt="">
      <p>具体而言：</p>
      <img src="../../assets/list4_1.png" alt="">
      <p>一般来说，我们的思维模式就两种：固定型思维模式和成长型思维模式。如果我们认为自己的智力和能力是一成不变的，那么我们拥有的就是“固定型思维”（fixed mindset）。</p>
      <p>如果我们认为所有的事情都离不开个人努力，这个世界上充满了那些帮助我们学习、成长的有趣挑战，我们拥有的就是“成长型思维”（growth mindset）。</p>
      <h4>具有成长型思维的人有哪些表现？</h4>
      <img src="../../assets/list4_2.png" alt="">
      <h4>成长型思维的发展历史</h4>
      <img src="../../assets/list4_3.png" alt="">
      <h4>成长型思维在美国教育趋势中独占鳌头</h4>
      <p>日前，美国独立网站Teach Thought发布了《2018年美国教育趋势》报告，该网站通过分析2018年教育行业的访客网络行为得出了美国人最关心的教育话题和最热门的教育趋势并。其中，成长型思维排在第一名。。</p>
      <p>以下是2018年美国教育趋势TOP20的内容：</p>
      <img src="../../assets/list4_4.png" alt="">
      <p>01 成长型思维（10分）</p>
      <p>02 创客学习（9.7分）</p>
      <p>03 布鲁姆教育目标分类学及其应用目标分类法（9.7分）</p>
      <p>04 信息素养（9.4分）</p>
      <p>05 个性化学习（9.0分）</p>
      <p>06 项目化学习（8.8分）</p>
      <p>07 团队学习（8.6分）</p>
      <p>08 混合式学习（8.5分）</p>
      <p>09 天才时光（8.2分）</p>
      <p>10 同理心（8.0分）</p>
      <p>11 教育技术支撑学生学习的适度性（7.8分）</p>
      <p>12 社会情感教育（7.5分）</p>
      <p>13 创新型学校办学（7.2分）</p>
      <p>14 机器人/编程（6.9分）</p>
      <p>15 多元评价（6.8分）</p>
      <p>16 全脑学习（6.5分）</p>
      <p>17 游戏化教学（6.3分）</p>
      <p>18 自适应学习算法（6.1分）</p>
      <p>19 游戏化学习（6.0分）</p>
      <p>20 移动学习（5.8分）</p>
      <h4>来自认知神经科学的支持</h4>
      <img src="../../assets/list4_5.png" alt="">
      <h4>成长型思维的学业提升模型</h4>
      <img src="../../assets/list4_6.png" alt="">
      <h4>中小学成长型思维课程框架：</h4>
      <img src="../../assets/list4_7.png" alt="">
      <h4>学业提升效果评估：</h4>
      <p>学生在参加完一学期的成长型思维课程后学业成绩显著提升</p>
      <img src="../../assets/list4_8.png" alt="">
      <p>学生在参加完一学期的成长型思维课程后各种心理变量得到显著提升</p>
      <img src="../../assets/list4_9.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: "list1",
  data() {
    return {
      
    };
  },
  props: ["listOrCon"],
  methods:{
    returnFun(){
      this.$emit("returnPage")
    }
  }
};
</script>
<style scoped src="../../assets/style/grandchild.css">
  /* @import '../assets/style/child.css'; */
</style>
<style scoped>
.tab>div{
  padding: 0;
}
.tab > div > span{
  cursor: pointer;
  display: inline-block;
  padding: 4px 10px;
  border-radius: 5px;
  color: #7ecef4;
  border: solid 1px #7ecef4
}
.tab > div > h4{
  font-size: 24px
}
.tab > div > h5{
  text-align: center;
  margin: 30px 0;
  font-size: 20px
}
</style>


// WEBPACK FOOTER //
// src/components/growthThinking/list1.vue